import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { DownloadService } from '../../../fastlane-common/services/download.service';
import { FormShareService } from '../share.service';

@Injectable()
export class PrintFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private downloadService: DownloadService,
    private shareService: FormShareService
  ) {
    super();
  }

  exec(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.downloadService
        .openFormSnapshot(
          this.shareService.formId,
          this.shareService.project.projectInfo.projectId
        )
        .subscribe(resolve, error => reject(error));
      // this.printConfirmation();
    });
  }

  // * This code used to work but not sure why or how it broke.
  // * Keeping it for now so that we can take a look at it later.
  // * It has been replaced with a new implementation using form snapshots and cloud storage
  // printConfirmation() {
  // let url = environment.apiUrl;
  // if (soloFormTypes.includes(this.shareService.formId.formType)) {
  //   url =
  //     url +
  //     `/report/${this.shareService.formId.formType}/${
  //       this.shareService.formId.projectGuid
  //     }/pdf`;
  // } else {
  //   url =
  //     url +
  //     `/report/${this.shareService.formId.formType}/${
  //       this.shareService.formId.projectGuid
  //     }/pdf?formIndex=${this.shareService.formId.formIndex}`;
  // }
  // window.open(url);
  // }
}
